export const key = {
  CREATE_APPROVAL: "createApprovalDT",
};
